module.exports = __webpack_public_path__ + "static/media/logos_50h_hkstp.d03b1baa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_hkstp.jpg
// module id = 217
// module chunks = 0